import type { IOptionItem } from '~/client/src/shared/components/OptionsList/types'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import {
  SubscribeUsersSelectorDataKeys,
  SubscribeUsersSelectorGroupingOption,
} from './SubscribeUsersSelector.store'

export const getSubscribeUsersSortingOptions = (): IOptionItem[] => [
  {
    key: SubscribeUsersSelectorDataKeys.USER,
    label: Localization.translator.name,
    glyph: 'name',
  },
]

// No explicit None: Display adds it for grouping.
export const getSubscribeUsersGroupingOptions = (): IOptionItem[] => [
  {
    key: SubscribeUsersSelectorGroupingOption.COMPANY,
    label: Localization.translator.company,
    glyph: 'company',
  },
  {
    key: SubscribeUsersSelectorGroupingOption.ROLE,
    label: Localization.translator.role,
  },
  {
    key: SubscribeUsersSelectorGroupingOption.TEAM,
    label: Localization.translator.team,
  },
  {
    key: SubscribeUsersSelectorGroupingOption.TRADE,
    label: Localization.translator.trade,
  },
  {
    key: SubscribeUsersSelectorGroupingOption.ACCOUNT_POSITION,
    label: Localization.translator.accountPosition,
  },
]
